import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { PropsWithChildren, useState } from "react";
import "./ToolTip.css";

interface ToolTipProps extends PropsWithChildren {
    content: string | JSX.Element;
    direction: string;
    offsetTop?: number;
    offsetBottom?: number;
    offsetLeft?: number;
    offsetRight?: number;
    customIcon?: JSX.Element;
    alignment?: string;
}

const Tooltip = (props: ToolTipProps) => {

  const offsetClass: React.CSSProperties = {
    top: props.offsetTop,
    bottom: props.offsetBottom,
    left: props.offsetLeft,
    right: props.offsetRight
  }

  const [active, setActive] = useState(false);
  const [timeoutInstance, setTimeoutInstance] = useState<NodeJS.Timeout | null>(null);

  const showTip = () => {
    setActive(true);
    if (timeoutInstance) {
      clearTimeout(timeoutInstance as NodeJS.Timeout)
      setTimeoutInstance(null);
    }
  };

  const hideTip = () => {
    setTimeoutInstance(setTimeout(() => {setActive(false)}, 500))
  };

  return (
    <div
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
    >
      {/* Wrapping */}
      {props.children}
      {active && (
        <div className={`Tooltip-Tip ${props.direction || "top"} ${props.alignment}`} style={offsetClass}>
          {/* Content */}
          <div className="icon">
           {props.customIcon ? props.customIcon : <FontAwesomeIcon icon={faCircleInfo} size="2x" color="#005ca6"/>}
          </div>
          <div className="tip-content" onMouseMove={showTip}>
            {props.content}
          </div>

        </div>
      )}
    </div>
  );
};

export default Tooltip;
